import { Alert } from '@apollo/orbit';
import React from 'react';

import { isEmbeddableExplorerRoute } from 'src/app/embeddableExplorer/isEmbeddableExplorerRoute';
import { ExplorerBehavioralFlags } from 'src/app/graph/explorerPage/explorerBehavioralFlags';
import { useGraphVisibility } from 'src/app/graph/hooks/useGraphVisibility';

export const PublicVariantWarning = ({
  className,
  settingsEndpointUrl,
  settingsSubscriptionUrl,
  explorerBehavioralFlags,
}: {
  className?: string;
  settingsEndpointUrl?: string | null;
  settingsSubscriptionUrl?: string | null;
  explorerBehavioralFlags?: ExplorerBehavioralFlags;
}) => {
  const graphVisibility = useGraphVisibility();

  if (
    graphVisibility !== 'public' ||
    (!settingsEndpointUrl && !settingsSubscriptionUrl) ||
    explorerBehavioralFlags?.shouldPostMessageOperations ||
    // we don't show this warning for the embeddable explorer
    // since you are on the site of the folks who configured the public graph
    isEmbeddableExplorerRoute()
  ) {
    return null;
  }
  const hasMultipleLinks = settingsSubscriptionUrl && settingsEndpointUrl;
  return (
    <Alert className={className} status="info">
      On submit, this information will be sent to{' '}
      {settingsEndpointUrl || settingsSubscriptionUrl}
      {hasMultipleLinks && (
        <> (or {settingsSubscriptionUrl} for subscriptions)</>
      )}
      , make sure you trust {hasMultipleLinks ? 'these urls' : 'this url'}.{' '}
    </Alert>
  );
};
